import { companyWelfareCampaignSchema } from 'app/src/msw/membership/schemas/campaign'
import { documentSchema } from 'app/src/msw/membership/schemas/document'
import { membershipStatusSchema, userWelfareModeSchema } from 'app/src/msw/membership/schemas/enums'
import { familyMembersSchema as userFamilyMemberSchema } from 'app/src/msw/membership/schemas/familyMembers'
import { membershipInfoSchema } from 'app/src/msw/membership/schemas/membershipInfo'
import {
  privacyDocumentUpdateRequestSchema,
  privacyDocumentUploadRequestSchema,
} from 'app/src/msw/membership/schemas/privacyDocument'
import { prizeGroupSchema } from 'app/src/msw/membership/schemas/prize'
import {
  FamilyMemberId,
  Membership,
  MembershipExtended,
  MembershipUpdateRequest,
} from 'app/src/services/welfareportal/membership-api'

// eslint-disable-next-line import/no-named-as-default
import z from 'zod'

export const membershipSchema: z.ZodType<Membership> = z.object({
  tenantId: z.string().max(55),
  membershipId: z.string().max(36),
  userId: z.string().max(255),
  userEmail: z.string().max(255),
  userIban: z
    .string()
    .max(255)

    .optional(),
  allowUserIbanEditing: z.boolean().optional(),
  userFiscalCode: z.string().max(16),
  userRegistrationNumber: z.string().max(255),
  userFirstName: z.string().max(100).optional(),
  userLastName: z.string().max(100).optional(),
  userFamilyMembers: z.array(userFamilyMemberSchema).optional(),
  userFamilyMembersPrivacyTemplateURL: z.string().optional(),
  companyWelfareId: z.number(),
  companyName: z.string().max(255),
  companyCode: z.string().max(50),
  companyDocuments: z.array(documentSchema).optional(),
  companyPrize: z.array(prizeGroupSchema).optional(),
  campaignId: z.string().max(255).optional(),
  status: membershipStatusSchema,
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  firstMembershipAt: z.string().datetime().optional(),
  welfarePercentage: z.number().min(0).max(100),
  welfareAmount: z.number().min(0).max(999999.99).optional(),
  bonusAmount: z.number().min(0).max(999999.99),
  taxPercentage: z.number().min(0).max(100),
  inpsPercentage: z.number().min(0).max(100),
  additionalInfoGroup: z.any().optional(),
  membershipStartDate: z.string().datetime(),
  membershipEndDate: z.string().datetime(),
})

export const membershipUpdateRequestSchema: z.ZodType<MembershipUpdateRequest> = z.object({
  userId: z.string().max(255),
  percentage: z.number().min(0).max(100).optional(),
  iban: z.string().min(5).max(255).optional(),
  email: z.string().max(255).optional(),
})

export const membershipExtendedSchema: z.ZodType<MembershipExtended> = z.object({
  membershipInfo: membershipInfoSchema,
  welfareCampaign: companyWelfareCampaignSchema,
  userWelfareMode: userWelfareModeSchema,
})

export const familyMemberIdSchema: z.ZodType<FamilyMemberId> = z.object({
  familyMemberId: z.string().max(255),
})

export { privacyDocumentUpdateRequestSchema, privacyDocumentUploadRequestSchema }
